import { render, staticRenderFns } from "./newCalcIcon.vue?vue&type=template&id=a420aa08&scoped=true"
import script from "./newCalcIcon.vue?vue&type=script&lang=js"
export * from "./newCalcIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a420aa08",
  null
  
)

export default component.exports